import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Security")
], -1);
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is this a Security Role? *")
], -1);
const _hoisted_7 = { class: "mt-4 space-y-4" };
const _hoisted_8 = { class: "flex items-start" };
const _hoisted_9 = { class: "h-5 flex items-center" };
const _hoisted_10 = ["checked", "disabled"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityRole",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_12 = { class: "flex items-start" };
const _hoisted_13 = { class: "h-5 flex items-center" };
const _hoisted_14 = ["disabled", "checked"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityRole-no",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is a Security Industry Authority Licence (SIA) Required? *")
], -1);
const _hoisted_20 = { class: "mt-4 space-y-4" };
const _hoisted_21 = { class: "flex items-start" };
const _hoisted_22 = { class: "h-5 flex items-center" };
const _hoisted_23 = ["checked", "disabled"];
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securitySIA",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_25 = { class: "flex items-start" };
const _hoisted_26 = { class: "h-5 flex items-center" };
const _hoisted_27 = ["checked", "disabled"];
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securitySIA",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_29 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_30 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is a Security Check (BS7858) Required? *")
], -1);
const _hoisted_32 = { class: "mt-4 space-y-4" };
const _hoisted_33 = { class: "flex items-start" };
const _hoisted_34 = { class: "h-5 flex items-center" };
const _hoisted_35 = ["disabled", "checked"];
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityCheck",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_37 = { class: "flex items-start" };
const _hoisted_38 = { class: "h-5 flex items-center" };
const _hoisted_39 = ["disabled", "checked"];
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityCheck",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_41 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_42 = { class: "text-sm text-red-500" };
const _hoisted_43 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Have the preliminary checks been carried out for BS7858 Security\n                  Clearance? *\n                ")
], -1);
const _hoisted_45 = { class: "mt-4 space-y-4" };
const _hoisted_46 = { class: "flex items-start" };
const _hoisted_47 = { class: "h-5 flex items-center" };
const _hoisted_48 = ["disabled", "checked"];
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityPreliminary",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_50 = { class: "flex items-start" };
const _hoisted_51 = { class: "h-5 flex items-center" };
const _hoisted_52 = ["disabled", "checked"];
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityPreliminary",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_54 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, "\n                Please note a start date cannot be confirmed unless the preliminary\n                checks are complete and we may need to return the ATR to you whilst\n                the checks are being completed.\n              ", -1);
const _hoisted_56 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Is a Security Baseline Standard Verification Record (BSVR) Check\n                  Required? (EDF Only)? *\n                ")
], -1);
const _hoisted_58 = { class: "mt-4 space-y-4" };
const _hoisted_59 = { class: "flex items-start" };
const _hoisted_60 = { class: "h-5 flex items-center" };
const _hoisted_61 = ["disabled", "checked"];
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityBSVR",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_63 = { class: "flex items-start" };
const _hoisted_64 = { class: "h-5 flex items-center" };
const _hoisted_65 = ["checked", "disabled"];
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityBSVR",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_67 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_68 = { class: "text-sm text-red-500" };
const _hoisted_69 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is Government Level Clearance Required? *")
], -1);
const _hoisted_71 = { class: "mt-4 space-y-4" };
const _hoisted_72 = { class: "flex items-start" };
const _hoisted_73 = { class: "h-5 flex items-center" };
const _hoisted_74 = ["checked", "disabled"];
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityGovernment",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_76 = { class: "flex items-start" };
const _hoisted_77 = { class: "h-5 flex items-center" };
const _hoisted_78 = ["disabled", "checked"];
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityGovernment",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_80 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_81 = {
    key: 0,
    class: "text-sm text-red-500"
};
const _hoisted_82 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is Counter Terrorism Check Required? *")
], -1);
const _hoisted_84 = { class: "mt-4 space-y-4" };
const _hoisted_85 = { class: "flex items-start" };
const _hoisted_86 = { class: "h-5 flex items-center" };
const _hoisted_87 = ["checked"];
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "counterTerrorism",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_89 = { class: "flex items-start" };
const _hoisted_90 = { class: "h-5 flex items-center" };
const _hoisted_91 = ["checked"];
const _hoisted_92 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "counterTerrorism",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_93 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_94 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_95 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is a Security Check Required? *")
], -1);
const _hoisted_96 = { class: "mt-4 space-y-4" };
const _hoisted_97 = { class: "flex items-start" };
const _hoisted_98 = { class: "h-5 flex items-center" };
const _hoisted_99 = ["checked"];
const _hoisted_100 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityHidden",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_101 = { class: "flex items-start" };
const _hoisted_102 = { class: "h-5 flex items-center" };
const _hoisted_103 = ["checked"];
const _hoisted_104 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityHidden",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_105 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_106 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_107 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is a Developed Vetting Check Required? *")
], -1);
const _hoisted_108 = { class: "mt-4 space-y-4" };
const _hoisted_109 = { class: "flex items-start" };
const _hoisted_110 = { class: "h-5 flex items-center" };
const _hoisted_111 = ["checked"];
const _hoisted_112 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "developedVetting",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_113 = { class: "flex items-start" };
const _hoisted_114 = { class: "h-5 flex items-center" };
const _hoisted_115 = ["checked"];
const _hoisted_116 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "developedVetting",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_117 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_118 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_119 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Does employee work at a DWP site (therefore BPSS Clearance is always a requirement)? *\n                ")
], -1);
const _hoisted_120 = { class: "mt-4 space-y-4" };
const _hoisted_121 = { class: "flex items-start" };
const _hoisted_122 = { class: "h-5 flex items-center" };
const _hoisted_123 = ["disabled", "checked"];
const _hoisted_124 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityDWP",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_125 = { class: "flex items-start" };
const _hoisted_126 = { class: "h-5 flex items-center" };
const _hoisted_127 = ["disabled", "checked"];
const _hoisted_128 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityDWP",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_129 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_130 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_131 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Please confirm if a CTC clearance is required (this will be arranged separately by site)? *\n                ")
], -1);
const _hoisted_132 = { class: "mt-4 space-y-4" };
const _hoisted_133 = { class: "flex items-start" };
const _hoisted_134 = { class: "h-5 flex items-center" };
const _hoisted_135 = ["disabled", "checked"];
const _hoisted_136 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityCTC",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes - HMCTS CTC Clearance is required")
], -1);
const _hoisted_137 = { class: "flex items-start" };
const _hoisted_138 = { class: "h-5 flex items-center" };
const _hoisted_139 = ["disabled", "checked"];
const _hoisted_140 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityCTC",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No - HMCTS CTC is not required")
], -1);
const _hoisted_141 = { class: "flex items-start" };
const _hoisted_142 = { class: "h-5 flex items-center" };
const _hoisted_143 = ["disabled", "checked"];
const _hoisted_144 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityCTC",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "N/A - Not a HMCTS role")
], -1);
const _hoisted_145 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_146 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, "\n                  If employee works at a HMCTs site, BPSS security clearance is automatically requested.\n                ", -1);
const _hoisted_147 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_148 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Does employee work at a NTC or Telant site (BPSS is not always required, please only tick if BPSS clearance is required) *\n                ")
], -1);
const _hoisted_149 = { class: "mt-4 space-y-4" };
const _hoisted_150 = { class: "flex items-start" };
const _hoisted_151 = { class: "h-5 flex items-center" };
const _hoisted_152 = ["disabled", "checked"];
const _hoisted_153 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityNTC",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_154 = { class: "flex items-start" };
const _hoisted_155 = { class: "h-5 flex items-center" };
const _hoisted_156 = ["disabled", "checked"];
const _hoisted_157 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityNTC",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_158 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_159 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_160 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is this a Security Role Carrying Out Mobile Patrols? *")
], -1);
const _hoisted_161 = { class: "mt-4 space-y-4" };
const _hoisted_162 = { class: "flex items-start" };
const _hoisted_163 = { class: "h-5 flex items-center" };
const _hoisted_164 = ["disabled", "checked"];
const _hoisted_165 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityMobile",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_166 = { class: "flex items-start" };
const _hoisted_167 = { class: "h-5 flex items-center" };
const _hoisted_168 = ["disabled", "checked"];
const _hoisted_169 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityMobile",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_170 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_171 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_172 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Can Employee Start Before Checks Complete? *")
], -1);
const _hoisted_173 = { class: "mt-4 space-y-4" };
const _hoisted_174 = { class: "flex items-start" };
const _hoisted_175 = { class: "h-5 flex items-center" };
const _hoisted_176 = ["disabled", "checked"];
const _hoisted_177 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityBefore",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_178 = { class: "flex items-start" };
const _hoisted_179 = { class: "h-5 flex items-center" };
const _hoisted_180 = ["disabled", "checked"];
const _hoisted_181 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityBefore",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_182 = { class: "flex items-start" };
const _hoisted_183 = { class: "h-5 flex items-center" };
const _hoisted_184 = ["disabled", "checked"];
const _hoisted_185 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "securityBefore",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "N/A")
], -1);
const _hoisted_186 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_187 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_188 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("input", {
                                        id: "radio-button-securityRole-yes",
                                        value: "Yes",
                                        name: "securityRole",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        checked: _ctx.formData.securityRole === 'Yes',
                                        disabled: _ctx.showApprovalSteps,
                                        onChange: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.securityRole.$touch()))
                                    }, null, 42, _hoisted_10)
                                ]),
                                _createTextVNode(),
                                _hoisted_11
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("input", {
                                        id: "radio-button-securityRole-no",
                                        value: "No",
                                        name: "securityRole",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.securityRole === 'No',
                                        onChange: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.securityRole.$touch()))
                                    }, null, 42, _hoisted_14)
                                ]),
                                _createTextVNode(),
                                _hoisted_15
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.securityRole.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n                * " + _toDisplayString(_ctx.v$.formData.securityRole.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.securityRole === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securitySIA-yes",
                                                value: "Yes",
                                                name: "securitySIA",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.securitySIA === 'Yes',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[4] || (_cache[4] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.securitySIA.$touch()))
                                            }, null, 42, _hoisted_23)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_24
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securitySIA-no",
                                                value: "No",
                                                name: "securitySIA",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.securitySIA === 'No',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[6] || (_cache[6] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.securitySIA.$touch()))
                                            }, null, 42, _hoisted_27)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_28
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securitySIA.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "\n                  * " + _toDisplayString(_ctx.v$.formData.securitySIA.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityCheck-yes",
                                                value: "Yes",
                                                name: "securityCheck",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityCheck === 'Yes',
                                                onChange: _cache[8] || (_cache[8] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.securityCheck.$touch()))
                                            }, null, 42, _hoisted_35)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_36
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityCheck-no",
                                                value: "No",
                                                name: "securityCheck",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityCheck === 'No',
                                                onChange: _cache[10] || (_cache[10] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.securityCheck.$touch()))
                                            }, null, 42, _hoisted_39)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_40
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityCheck.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityCheck.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("p", _hoisted_42, "\n                if a BS7858 is required, please refer to the Recruitment Guidance\n                Notes to complete the Security Guard Application Assessment and\n                forward this directly to the external vetting company, 15C\n              ", 512), [
                                    [_vShow, _ctx.formData.securityCheck === 'Yes']
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityPreliminary-yes",
                                                value: "Yes",
                                                name: "securityPreliminary",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityPreliminary === 'Yes',
                                                onChange: _cache[12] || (_cache[12] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.securityPreliminary.$touch()))
                                            }, null, 42, _hoisted_48)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_49
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityPreliminary-no",
                                                value: "No",
                                                name: "securityPreliminary",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityPreliminary === 'No',
                                                onChange: _cache[14] || (_cache[14] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.securityPreliminary.$touch()))
                                            }, null, 42, _hoisted_52)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_53
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityPreliminary.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityPreliminary.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _hoisted_55
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityBSVR-yes",
                                                value: "Yes",
                                                name: "securityBSVR",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityBSVR === 'Yes',
                                                onChange: _cache[16] || (_cache[16] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.securityBSVR.$touch()))
                                            }, null, 42, _hoisted_61)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_62
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_63, [
                                        _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityBSVR-no",
                                                value: "No",
                                                name: "securityBSVR",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.securityBSVR === 'No',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[18] || (_cache[18] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[19] || (_cache[19] = ($event) => (_ctx.v$.formData.securityBSVR.$touch()))
                                            }, null, 42, _hoisted_65)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_66
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityBSVR.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityBSVR.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("p", _hoisted_68, "\n                A BSVR check will include a CTC check, both of which are arranged and managed locally by site.\n              ", 512), [
                                    [_vShow, _ctx.formData.securityBSVR === 'Yes']
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_71, [
                                    _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityGovernment-yes",
                                                value: "Yes",
                                                name: "securityGovernment",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.securityGovernment === 'Yes',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[20] || (_cache[20] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[21] || (_cache[21] = ($event) => (_ctx.v$.formData.securityGovernment.$touch()))
                                            }, null, 42, _hoisted_74)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_75
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("div", _hoisted_77, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityGovernment-no",
                                                value: "No",
                                                name: "securityGovernment",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityGovernment === 'No',
                                                onChange: _cache[22] || (_cache[22] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[23] || (_cache[23] = ($event) => (_ctx.v$.formData.securityGovernment.$touch()))
                                            }, null, 42, _hoisted_78)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_79
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityGovernment.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityGovernment.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                (_ctx.formData.securityGovernment === 'Yes')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_81, "\n                The Government Level Clearance process is arranged and managed locally by site.\n              "))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("div", _hoisted_85, [
                                            _createElementVNode("div", _hoisted_86, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-counterTerrorism-yes",
                                                    value: "Yes",
                                                    name: "counterTerrorism",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.counterTerrorism === 'Yes',
                                                    onChange: _cache[24] || (_cache[24] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[25] || (_cache[25] = ($event) => (_ctx.v$.formData.counterTerrorism.$touch()))
                                                }, null, 40, _hoisted_87)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_88
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_89, [
                                            _createElementVNode("div", _hoisted_90, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-counterTerrorism-no",
                                                    value: "No",
                                                    name: "counterTerrorism",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.counterTerrorism === 'No',
                                                    onChange: _cache[26] || (_cache[26] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[27] || (_cache[27] = ($event) => (_ctx.v$.formData.counterTerrorism.$touch()))
                                                }, null, 40, _hoisted_91)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_92
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.v$.formData.counterTerrorism.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, "\n                    * " + _toDisplayString(_ctx.v$.formData.counterTerrorism.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_94, [
                                    _hoisted_95,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_96, [
                                        _createElementVNode("div", _hoisted_97, [
                                            _createElementVNode("div", _hoisted_98, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-securityHidden-yes",
                                                    value: "Yes",
                                                    name: "securityHidden",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.securityHidden === 'Yes',
                                                    onChange: _cache[28] || (_cache[28] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[29] || (_cache[29] = ($event) => (_ctx.v$.formData.securityHidden.$touch()))
                                                }, null, 40, _hoisted_99)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_100
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_101, [
                                            _createElementVNode("div", _hoisted_102, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-securityHidden-no",
                                                    value: "No",
                                                    name: "securityHidden",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.securityHidden === 'No',
                                                    onChange: _cache[30] || (_cache[30] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[31] || (_cache[31] = ($event) => (_ctx.v$.formData.securityHidden.$touch()))
                                                }, null, 40, _hoisted_103)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_104
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.v$.formData.securityHidden.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_105, "\n                    * " + _toDisplayString(_ctx.v$.formData.securityHidden.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_106, [
                                    _hoisted_107,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_108, [
                                        _createElementVNode("div", _hoisted_109, [
                                            _createElementVNode("div", _hoisted_110, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-developedVetting-yes",
                                                    value: "Yes",
                                                    name: "developedVetting",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.developedVetting === 'Yes',
                                                    onChange: _cache[32] || (_cache[32] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[33] || (_cache[33] = ($event) => (_ctx.v$.formData.developedVetting.$touch()))
                                                }, null, 40, _hoisted_111)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_112
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_113, [
                                            _createElementVNode("div", _hoisted_114, [
                                                _createElementVNode("input", {
                                                    id: "radio-button-developedVetting-no",
                                                    value: "No",
                                                    name: "developedVetting",
                                                    type: "radio",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                                    checked: _ctx.formData.developedVetting === 'No',
                                                    onChange: _cache[34] || (_cache[34] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[35] || (_cache[35] = ($event) => (_ctx.v$.formData.developedVetting.$touch()))
                                                }, null, 40, _hoisted_115)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_116
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.v$.formData.developedVetting.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, "\n                    * " + _toDisplayString(_ctx.v$.formData.developedVetting.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ], 512), [
                                [_vShow, _ctx.formData.securityGovernment === 'Yes']
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_118, [
                                _hoisted_119,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_120, [
                                    _createElementVNode("div", _hoisted_121, [
                                        _createElementVNode("div", _hoisted_122, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityDWP-yes",
                                                value: "Yes",
                                                name: "securityDWP",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityDWP === 'Yes',
                                                onChange: _cache[36] || (_cache[36] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[37] || (_cache[37] = ($event) => (_ctx.v$.formData.securityDWP.$touch()))
                                            }, null, 42, _hoisted_123)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_124
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_125, [
                                        _createElementVNode("div", _hoisted_126, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityDWP-no",
                                                value: "No",
                                                name: "securityDWP",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityDWP === 'No',
                                                onChange: _cache[38] || (_cache[38] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[39] || (_cache[39] = ($event) => (_ctx.v$.formData.securityDWP.$touch()))
                                            }, null, 42, _hoisted_127)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_128
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityDWP.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_129, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityDWP.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_130, [
                                _hoisted_131,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, [
                                        _createElementVNode("div", _hoisted_134, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityCTC-yes",
                                                value: "Yes",
                                                name: "securityCTC",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityCTC === 'Yes',
                                                onChange: _cache[40] || (_cache[40] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[41] || (_cache[41] = ($event) => (_ctx.v$.formData.securityCTC.$touch()))
                                            }, null, 42, _hoisted_135)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_136
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_137, [
                                        _createElementVNode("div", _hoisted_138, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityCTC-no",
                                                value: "No",
                                                name: "securityCTC",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityCTC === 'No',
                                                onChange: _cache[42] || (_cache[42] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[43] || (_cache[43] = ($event) => (_ctx.v$.formData.securityCTC.$touch()))
                                            }, null, 42, _hoisted_139)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_140
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_141, [
                                        _createElementVNode("div", _hoisted_142, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityCTC-na",
                                                value: "N/A",
                                                name: "securityCTC",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityCTC === 'N/A',
                                                onChange: _cache[44] || (_cache[44] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[45] || (_cache[45] = ($event) => (_ctx.v$.formData.securityCTC.$touch()))
                                            }, null, 42, _hoisted_143)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_144
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityCTC.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_145, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityCTC.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _hoisted_146
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_147, [
                                _hoisted_148,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("div", _hoisted_150, [
                                        _createElementVNode("div", _hoisted_151, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityNTC-yes",
                                                value: "Yes",
                                                name: "securityNTC",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityNTC === 'Yes',
                                                onChange: _cache[46] || (_cache[46] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[47] || (_cache[47] = ($event) => (_ctx.v$.formData.securityNTC.$touch()))
                                            }, null, 42, _hoisted_152)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_153
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_154, [
                                        _createElementVNode("div", _hoisted_155, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityNTC-no",
                                                value: "No",
                                                name: "securityNTC",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityNTC === 'No',
                                                onChange: _cache[48] || (_cache[48] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[49] || (_cache[49] = ($event) => (_ctx.v$.formData.securityNTC.$touch()))
                                            }, null, 42, _hoisted_156)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_157
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityNTC.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_158, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityNTC.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_159, [
                                _hoisted_160,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_161, [
                                    _createElementVNode("div", _hoisted_162, [
                                        _createElementVNode("div", _hoisted_163, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityMobile-yes",
                                                value: "Yes",
                                                name: "securityMobile",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityMobile === 'Yes',
                                                onChange: _cache[50] || (_cache[50] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[51] || (_cache[51] = ($event) => (_ctx.v$.formData.securityMobile.$touch()))
                                            }, null, 42, _hoisted_164)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_165
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_166, [
                                        _createElementVNode("div", _hoisted_167, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityDWP-no",
                                                value: "No",
                                                name: "securityMobile",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityMobile === 'No',
                                                onChange: _cache[52] || (_cache[52] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[53] || (_cache[53] = ($event) => (_ctx.v$.formData.securityMobile.$touch()))
                                            }, null, 42, _hoisted_168)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_169
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityMobile.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_170, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityMobile.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_171, [
                                _hoisted_172,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_173, [
                                    _createElementVNode("div", _hoisted_174, [
                                        _createElementVNode("div", _hoisted_175, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityBefore-yes",
                                                value: "Yes",
                                                name: "securityBefore",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityBefore === 'Yes',
                                                onChange: _cache[54] || (_cache[54] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[55] || (_cache[55] = ($event) => (_ctx.v$.formData.securityBefore.$touch()))
                                            }, null, 42, _hoisted_176)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_177
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_178, [
                                        _createElementVNode("div", _hoisted_179, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityBefore-no",
                                                value: "No",
                                                name: "securityBefore",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityBefore === 'No',
                                                onChange: _cache[56] || (_cache[56] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[57] || (_cache[57] = ($event) => (_ctx.v$.formData.securityBefore.$touch()))
                                            }, null, 42, _hoisted_180)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_181
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_182, [
                                        _createElementVNode("div", _hoisted_183, [
                                            _createElementVNode("input", {
                                                id: "radio-button-securityBefore-na",
                                                value: "N/A",
                                                name: "securityBefore",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.securityBefore === 'N/A',
                                                onChange: _cache[58] || (_cache[58] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[59] || (_cache[59] = ($event) => (_ctx.v$.formData.securityBefore.$touch()))
                                            }, null, 42, _hoisted_184)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_185
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.securityBefore.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_186, "\n                  * " + _toDisplayString(_ctx.v$.formData.securityBefore.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[60] || (_cache[60] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[61] || (_cache[61] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_188)
            ]))
            : _createCommentVNode("", true)
    ]));
}
